import React from 'react';

import { block } from 'bem-cn';

import MiniTag from '../MiniTag';
import Typography from '../Typography';

import './entity-wrapper.scss';

const b = block('entity-wrapper');

type EntityWrapperPropsType = {
  title: string;
  image: string;
  onImageClick?: () => void;
  onTitleClick?: () => void;
  backgroundColor: string;
  tags: any; // TODO ImmutablePropTypes.list
};

const EntityWrapper = ({
  image,
  title,
  backgroundColor,
  onImageClick = () => {},
  onTitleClick = () => {},
  tags,
}: EntityWrapperPropsType) => (
  <div className={b()}>
    <div
      className={b('image')}
      style={{ backgroundColor }}
      onClick={onImageClick}
      data-testid='entity-wrapper-image-wrapper'
    >
      {image && (
        <img src={image} alt={title} data-testid='entity-wrapper-image' />
      )}
    </div>
    <div className={b('info')}>
      <Typography
        component='h3'
        onClick={onTitleClick}
        data-testid='entity-wrapper-title'
        className={b('title').toString()}
        variant={Typography.THEME.VARIANTS.CARD_TITLE_NORMAL}
      >
        {title}
      </Typography>
      {tags && tags.size > 0 && (
        <div className={b('tags')} data-testid='entity-wrapper-tags'>
          {tags?.map((tag: any /* TODO */) => (
            <MiniTag key={tag.get('id')} tag={tag.get('title') as string} />
          ))}
        </div>
      )}
    </div>
  </div>
);

export default EntityWrapper;
